import Raven from 'raven-js';

// Use of Webpack DefinePlugin for "VERSION" and "process.env.NODE_ENV"

const environmentsToLog = ['production'];

const getVersion = () => VERSION;
const getEnvironment = () => process.env.NODE_ENV;
const shouldLogEnvironment = () => environmentsToLog.indexOf(getEnvironment()) !== -1;

const sentryConfig = {
  release: getVersion(),
  environment: getEnvironment(),
  // Paths that will be considered part of the Sentry application
  includePaths: [/\.moo\.com\/m4b/, /\.moo\.com\/mbs/, /\.moo\.com\/bascule/],
  // Errors to be excluded from logging
  ignoreErrors: [
    // Bug in Chrome iOS related to autofilling forms,
    '__gCrWeb.autofill.extractForms',
  ],
  // URLs to be excluded from logging
  ignoreUrls: [
    // Answerdash
    /answerdash\.com\/answerdash.min.js/,
    // Facebook
    /graph\.facebook\.com/i,
    /connect\.facebook\.net\/en_US\/all\.js/i,
    // Kaspersky Antivirus
    /kaspersky-labs\.com/i,
    // Chrome extensions
    /extensions\//i,
    /^chrome:\/\//i,
    // Firefox extensions
    /^resource:\/\//i,
  ],
};

export const errorLogInit = () => {
  if (shouldLogEnvironment()) {
    Raven.config('https://f573ef683c434f9097b1fa6eacd15cb0@sentry.io/152598', sentryConfig).install();

    window.onunhandledrejection = (evt) => {
      Raven.captureException(evt.reason);
    };
  }
};

export const errorLogging = (message, ex) => {
  if (shouldLogEnvironment()) {
    Raven.captureMessage(message).captureException(ex);
    return;
  }
  // eslint-disable-next-line no-console
  console.error('This should have been logged in Sentry:', message, ex);
};

export const getActionErrorMessage = (action, defaultMessage = 'Oops - Something went wrong.') => {
  if (action.error && action.error.message) {
    return action.error.message;
  }
  return defaultMessage;
};
